import { useEffect, useState } from "react";

export const TypingAnimation = ({ wordings }) => {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const words = wordings;
  const typingSpeed = 50; // Adjust typing speed here
  const repeatInterval = 5000; // Repeat every x seconds

  useEffect(() => {
    let typingInterval;

    if (index < words.length) {
      typingInterval = setInterval(() => {
        setText(words.slice(0, index + 1));
        setIndex(index + 1);
      }, typingSpeed);
    } else {
      setTimeout(() => {
        setText("");
        setIndex(0);
      }, repeatInterval);
    }

    return () => clearInterval(typingInterval);
  }, [index, words, typingSpeed, repeatInterval]);

  return (
    <div className="text-customMainColor">
      <span>{text}</span>
    </div>
  );
};